import TomSelect from 'tom-select';

document.querySelectorAll('.ts-select__wrapper').forEach((el) => {
  const settings = {
    maxItems: null,
    persist: false,
    controlInput: null,
    maxOptions: null,
    openOnFocus: true,
    itemClass: 'item',
    plugins: {
      checkbox_options: {
        checkedClassNames: ['ts-checked'],
        uncheckedClassNames: ['ts-unchecked'],
      },
      remove_button: {
        title: 'Entferne das item',
        label: `<svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.66693 5.50028L0.000570296 9.16664L1.3339 10.5L5.00026 6.83361L8.66664 10.5L9.99997 9.16667L6.33359 5.50028L10.0005 1.83333L8.66721 0.5L5.00026 4.16696L1.33333 0.500027L0 1.83336L3.66693 5.50028Z" fill="white"/>
                </svg>`,
      },
    },
  };

  // eslint-disable-next-line
  new TomSelect(el, settings, {
  });
});
